export default __webpack_public_path__ + "static/media/testi1.aad13f90.jpg";